import { IonCol, IonGrid, IonItemDivider, IonRow } from '@ionic/react';
import TransactionListItem from '@/shared/components/TransactionListItem/TransactionListItem';
import styles from './TransactionList.module.css';
import LoadingSpinner from '@/shared/components/LoadingSpinner/LoadingSpinner';
import { CryptoWithdrawal } from '@/types/crypto';
import { t } from 'i18next';

type Props = {
  isLoading: boolean;
  transactions: CryptoWithdrawal[] | undefined;
};

const TransactionList: React.FC<Props> = ({ isLoading, transactions }) => {
  return (
    <IonGrid fixed={true} className={styles.transactionsGrid}>
      <IonRow className={styles.rowItem} class="ion-align-items-center; ion-justify-content-center">
        <IonCol size="2" className={`${styles.columnHeader} ${styles.cryptoColumnHeader}`}>
          {t('transactions.list.cryptocurrency')}
        </IonCol>
        <IonCol size="2" className={styles.columnHeader}>
          {t('transactions.list.transaction_type')}
        </IonCol>
        <IonCol size="3" className={styles.columnHeader}>
          {t('transactions.list.date')}
        </IonCol>
        <IonCol size="3" className={styles.columnHeader} class="ion-text-end">
          {t('transactions.list.amount')}
        </IonCol>
        <IonCol size="2" className={`${styles.columnHeader} ${styles.statusColumnHeader}`} class="ion-text-end">
          {t('transactions.list.status')}
        </IonCol>
      </IonRow>
      <IonItemDivider className={styles.lineDivider} />
      {isLoading && <LoadingSpinner />}
      {!isLoading &&
        transactions?.map((transaction) => <TransactionListItem key={transaction.uuid} transaction={transaction} />)}
    </IonGrid>
  );
};

export default TransactionList;
